import type {
  CreatableTicketCategoryLocationDto,
  CreatableTicketCategoryNodeDto,
  CreatableTicketCategoryV2Dto,
  TicketRequest,
  UserDetailsDto,
  UserDto,
} from "@/api/types";
import type { FormImage } from "@/components/ImageInput/useImageInput";
import type { FormVideo } from "@/components/VideoInput/useVideoInput";

export enum CreateTicketModalStep {
  // Admin steps
  SELECT_REPORTER = "select-reporter",
  // Generic steps
  SELECT_CATEGORY = "select-ticket-category",
  VIEW_POTENTIAL_DUPLICATE_TICKETS = "view-potential-duplicate-tickets",
  ADD_ATTACHMENTS = "add-attachments",
  ADD_INFORMATION = "add-information",
  ADD_CONTACT_INFORMATION = "add-contact-information",
  CONFIRM = "confirm",
  // the repair provider appointment steps (replace CONFIRM when the category/node routes to the integration)
  APPOINTMENT_LOADING = "appointment-loading",
  APPOINTMENT_PICK_MOMENT = "appointment-pick-moment",
  APPOINTMENT_PREVIEW = "appointment-preview",
  // Decision-tree steps
  SELECT_TREE_LOCATION = "select-ticket-location",
  SELECT_TREE_ROOT_NODE = "select-tree-root-node",
  SELECT_TREE_NODE = "select-tree-node",
}

export type CreateTicketModalFormValues = {
  title: TicketRequest["title"];
  content: TicketRequest["content"];
  category: CreatableTicketCategoryV2Dto | undefined;
  visibility: TicketRequest["visibility"];
  images: FormImage[];
  videos: FormVideo[];
  phoneNumber: string | undefined;
  isRegulationsAccepted: boolean;
  tree: {
    location: CreatableTicketCategoryLocationDto | undefined;
    path: CreatableTicketCategoryNodeDto[];
  };
  reporter: UserDetailsDto | undefined;
  assignee: UserDto | undefined | null;
};
